import { lift, wrapIn } from 'prosemirror-commands';
import { icons, MenuItem } from 'prosemirror-menu';
import { NodeType, Schema } from 'prosemirror-model';

const wrapItem = (nodeType: NodeType, options) => {
  return new MenuItem({
    ...options,
    run(state, dispatch) {
      return wrapIn(nodeType, options.attrs)(state, dispatch);
    },
    enable(state) {
      return wrapIn(
        nodeType,
        options.attrs instanceof Function ? null : options.attrs,
      )(state);
    },
  });
};

export function listMenu(schema: Schema) {
  return [
    wrapItem(schema.nodes.bullet_list, {
      title: 'Bullet list',
      icon: icons.bulletList,
    }),
    wrapItem(schema.nodes.ordered_list, {
      title: 'Ordered list',
      icon: icons.orderedList,
    }),
    // wrapItem(schema.nodes.blockquote, {
    //   title: 'Quote',
    //   icon: icons.blockquote,
    // }),
    // new MenuItem({
    //   title: 'Join with above block',
    //   run: joinUp,
    //   enable: state => joinUp(state),
    //   icon: icons.join,
    //   class: undefined,
    //   css: undefined,
    // }),
    new MenuItem({
      title: 'Lift out of enclosing block',
      run: state => lift(state),
      enable: state => lift(state),
      icon: icons.lift,
      class: undefined,
      css: undefined,
    }),
  ];
}
